import { render } from "./B2bPageIssue.vue?vue&type=template&id=7e8f084a&scoped=true&lang=pug"
import script from "./B2bPageIssue.vue?vue&type=script&lang=js"
export * from "./B2bPageIssue.vue?vue&type=script&lang=js"

import "./B2bPageIssue.vue?vue&type=style&index=0&id=7e8f084a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8f084a"]])

export default __exports__